import React from 'react';

interface InvoiceLineLabelProps {}

export const InvoiceLineLabel: React.FC<InvoiceLineLabelProps> = props => {
  return (
    <label
      style={{
        color: '#525252',
        marginRight: 0,
        marginBottom: 1,
        whiteSpace: 'nowrap',
        fontSize: '12px',
      }}>
      {props.children}
    </label>
  );
};
